/* ============================================================
   MAGDA BUTRYM — Tabs + Stock Status + Fixes
   Replace magda-tabs.js in Assets with this file.
   ============================================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* ── Guard: only run on product pages ─────────────────────── */
  var isProductPage = document.querySelector('.product-single') !== null;
  if (!isProductPage) return;

  /* ── 1. CONVERT ACCORDIONS → HORIZONTAL TABS ──────────────── */
  var metas = document.querySelector('.product-single__metas');
  if (metas) {
    var accordions = metas.querySelectorAll('.product-more-info.accordion');
    if (accordions.length > 0) {
      var tabs = [];
      accordions.forEach(function(acc) {
        var titleEl  = acc.querySelector('.collapse_title span');
        var contentEl = acc.querySelector('.panel-collapse');
        if (titleEl && contentEl) {
          tabs.push({ title: titleEl.textContent.trim(), content: contentEl, accordion: acc });
        }
      });

      if (tabs.length > 0) {
        var nav = document.createElement('div');
        nav.className = 'magda-tabs-nav';

        tabs.forEach(function(tab, i) {
          var btn = document.createElement('button');
          btn.textContent = tab.title;
          btn.setAttribute('data-tab-index', i);
          if (i === 0) btn.className = 'active';
          nav.appendChild(btn);
        });

        accordions[0].parentNode.insertBefore(nav, accordions[0]);
        tabs[0].content.classList.add('magda-active');

        nav.addEventListener('click', function(e) {
          if (e.target.tagName !== 'BUTTON') return;
          var index = parseInt(e.target.getAttribute('data-tab-index'));
          nav.querySelectorAll('button').forEach(function(btn) { btn.classList.remove('active'); });
          e.target.classList.add('active');
          tabs.forEach(function(tab, i) {
            tab.content.classList.toggle('magda-active', i === index);
          });
        });
      }
    }
  }

  /* ── 2. STOCK STATUS LABEL + ESTIMATED DELIVERY ────────────── 
     Requires in theme.liquid before magda-tabs.js:
       window.marmarTemplate    = {{ request.template.name | json }};
       window.marmarCollections = {{ product.collections | map: 'handle' | json }};
       window.marmarStockQtys   = {{ product.variants | map: 'inventory_quantity' | json }};

     COLLECTION RULES:
       Any variant qty > 0          → In-Stock        | delivery: unchanged
       Collection: fall-winter-*    → Made-To-Order   | delivery: 4 to 6 weeks
       Collection: pre-fall-*       → Pre-Order        | delivery: unchanged
       Collection: pre-order        → Pre-Order        | delivery: unchanged
       Collection: r27              → Pre-Order        | delivery: 6 to 8 weeks
       Everything else              → Made-To-Order   | delivery: unchanged
  */

  /* Shared: collection handles string used throughout */
  var collections = (window.marmarCollections || []).join(' ').toLowerCase();

  var priceContainer = document.querySelector('.product-single .product-price') ||
                       document.querySelector('.product-single .price-container');

  if (priceContainer) {

    /* ── Identify collection type ── */
    var hasPhysicalStock = (window.marmarStockQtys || []).some(function(qty) { return qty > 0; });

    var isFallWinter = collections.indexOf('fall-winter') > -1 ||
                       collections.indexOf('fall_winter') > -1;

    var isPreFall    = collections.indexOf('pre-fall') > -1 ||
                       collections.indexOf('pre_fall') > -1;

    var isPreOrder   = collections.indexOf('pre-order') > -1 ||
                       collections.indexOf('pre_order') > -1;

    var isR27        = collections.indexOf('r27') > -1;

    /* ── Determine status label ── */
    var statusText  = null;
    var statusClass = null;

    if (hasPhysicalStock) {
      statusText  = 'In-Stock';
      statusClass = 'in-stock';
    } else if (isR27) {
      statusText  = 'Pre-Order';
      statusClass = 'pre-order';
    } else if (isPreFall || isPreOrder) {
      statusText  = 'Pre-Order';
      statusClass = 'pre-order';
    } else if (isFallWinter) {
      statusText  = 'Made-To-Order';
      statusClass = 'made-to-order';
    } else {
      statusText  = 'Made-To-Order';
      statusClass = 'made-to-order';
    }

    if (statusText) {
      var statusDiv = document.createElement('div');
      statusDiv.className = 'magda-stock-status ' + statusClass;
      statusDiv.textContent = statusText;
      priceContainer.parentNode.insertBefore(statusDiv, priceContainer.nextSibling);
    }
  }

  /* ── 3. HIDE DUPLICATE OPTIONS ROW (single-value variants) ─── */
  var variantWrappers = document.querySelectorAll('.product-single .variants-wrapper');
  variantWrappers.forEach(function(wrapper) {
    var options = wrapper.querySelectorAll('.single-option-selector');
    if (options.length <= 1) {
      var children = wrapper.children;
      for (var i = 0; i < children.length; i++) {
        if (!children[i].classList.contains('variants__label')) {
          children[i].style.display = 'none';
        }
      }
      wrapper.style.marginBottom = '10px';
    }
  });

  /* ── 4. DISABLE IMAGE LIGHTBOX/POPUP ─────────────────────── */
  var popupLinks = document.querySelectorAll(
    '.product-single .bwp-single-image a[data-fancybox],' +
    '.product-single .bwp-single-image [data-popup],' +
    '.product-single .bwp-single-image a[href*="cdn.shopify"]'
  );
  popupLinks.forEach(function(el) {
    el.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); }, true);
    el.style.cursor = 'default';
    el.removeAttribute('data-fancybox');
  });

  /* ── 5. KILL LAZY LOAD BACKGROUND COLOR ──────────────────── */
  function killBgColors() {
    var els = document.querySelectorAll(
      '.product-single .bwp-single-image [style],' +
      '.product-single .bwp-single-image .product-single__media-image,' +
      '.product-single .bwp-single-image .img-wrapper,' +
      '.product-single .bwp-single-image .image-wrap,' +
      '.product-single .bwp-single-image .main_media-content > *,' +
      '.product-single .bwp-single-image .slick-slide > *,' +
      '.product-single .bwp-single-image .slick-slide,' +
      '.product-single .bwp-single-image .media-item,' +
      '.product-single .bwp-single-image .product-featured-media'
    );
    els.forEach(function(el) {
      el.style.setProperty('background-color', 'transparent', 'important');
      el.style.setProperty('background', 'transparent', 'important');
    });
  }
  killBgColors();
  setTimeout(killBgColors, 500);
  setTimeout(killBgColors, 1500);
  setTimeout(killBgColors, 3000);

  /* ── 6. ESTIMATED DELIVERY OVERRIDE ──────────────────────────
     Calculates a date range from today:
     fall-winter  → today + 4 weeks  to  today + 6 weeks
     r27          → today + 6 weeks  to  today + 8 weeks
  */

  function calcDeliveryHTML(weeksFrom, weeksTo) {
    var days  = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var now  = new Date();
    var from = new Date(now.getTime() + weeksFrom * 7 * 24 * 60 * 60 * 1000);
    var to   = new Date(now.getTime() + weeksTo   * 7 * 24 * 60 * 60 * 1000);

    /* Countdown to midnight */
    var midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    var diff = midnight - now;
    var hoursLeft   = Math.floor(diff / (1000 * 60 * 60));
    var minutesLeft = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    var fromStr = days[from.getDay()] + ', ' + months[from.getMonth()] + ' ' + from.getDate();
    var toStr   = days[to.getDay()]   + ', ' + months[to.getMonth()]   + ' ' + to.getDate();

    return 'Order in the next <strong>' + hoursLeft + ' hours ' + minutesLeft + ' minutes</strong>'
         + ' to get it between <strong><u>' + fromStr + '</u></strong>'
         + ' and <strong><u>' + toStr + '</u></strong>';
  }

  var deliveryHTML = null;

  if (collections.indexOf('fall-winter') > -1 || collections.indexOf('fall_winter') > -1) {
    deliveryHTML = calcDeliveryHTML(4, 6);
  } else if (collections.indexOf('r27') > -1) {
    deliveryHTML = calcDeliveryHTML(6, 8);
  }

  if (deliveryHTML) {
    function overrideDelivery() {
      var deliveryEl = document.querySelector('.product-single .estimated_delivery') ||
                       document.querySelector('.product-single .section-estimated_delivery .estimated_delivery') ||
                       document.querySelector('.product-single [class*="estimated_delivery"]');

      if (!deliveryEl) return;

      var iconEl = deliveryEl.querySelector('.icons');

      if (iconEl) {
        /* Keep icon, replace rest with our HTML */
        var iconClone = iconEl.cloneNode(true);
        deliveryEl.innerHTML = '';
        deliveryEl.appendChild(iconClone);
        var textSpan = document.createElement('span');
        textSpan.innerHTML = deliveryHTML;
        deliveryEl.appendChild(textSpan);
      } else {
        deliveryEl.innerHTML = deliveryHTML;
      }
    }

    overrideDelivery();
    setTimeout(overrideDelivery, 800);
    setTimeout(overrideDelivery, 2000);
  }

  /* ── 7. REMOVE CLOSE-STICKY DIVIDER ─────────────────────── */
  var closeStickyEl = document.querySelector('.product-single .close-sticky');
  if (closeStickyEl) closeStickyEl.remove();

});
